<template>
  <a-modal v-model="modal" title="差异处理" width="85%" :maskClosable="false" :dialog-style="{ top: '30px' }" :body-style="{ maxHeight: '80vh', overflowY: 'auto' }">
    <div>
      <ls-info-form :custom-width="{receiveFileList:'100%'}">
        <ls-info-item title="组织" :value="formData.organizationName" slot="organizationName"></ls-info-item>
        <ls-info-item title="物料编码" :value="formData.itemCode" slot="itemCode"></ls-info-item>
        <ls-info-item title="物料名称" :value="formData.itemName" slot="itemName" :IsContentTip="true" placement="topLeft" />
        <ls-info-item title="物料描述" :value="formData.itemDescription" slot="itemDescription" :IsContentTip="true" placement="topLeft" />
        <ls-info-item title="生效日期" slot="startDate">
          <a-date-picker v-model="formData.startDate" valueFormat="YYYY-MM-DD 00:00:00" :disabled-date="disabledDate"/>
        </ls-info-item>
      </ls-info-form>
      <a-tabs v-model="tabSelect" :animated="false" class="tab-custom-content">
        <a-tab-pane :key="1" tab="BOM明细对比">
          <a-table
            bordered
            ref="modalTable"
            :columns="columns"
            :data-source="formData.details"
            :pagination="false"
            row-key="indexId"
            :scroll="{ y: '50vh' }"
          ></a-table>
        </a-tab-pane>
      </a-tabs>
    </div>
    <template #footer>
      <a-space>
        <a-button v-hasPermi="['mdm:mbomBillStructures:edit','mdm:mbomBillStructures:editfix']" @click="onOpenUpdate">修改</a-button>
        <a-button v-hasPermi="['mdm:mbomBillStructures:diffApply']" :loading="loading" @click="onIfUpgrade(false)">不升级</a-button>
        <a-button v-hasPermi="['mdm:mbomBillStructures:diffApply']" type="primary" @click="onIfUpgrade(true)" :loading="loading">确认升级</a-button>
      </a-space>
    </template>
  </a-modal>
</template>

<script>
import cloneDeep from 'lodash.clonedeep'
import { apiMbomBillStructuresDiffDetail, apiMbomBillStructuresApply } from '@/api/mdm/matter/manufacture-mbom.js'
export default {
  name: "DifferenceModal",
  props: {
  },
  data () {
    return {
      modal: false,
      loading: false,
      tabSelect: 1,
      formData: {},
      bomList: [],
      columns: [
        {
          title: '物料信息',
          align: 'center',
          dataIndex: 'materialInfo',
          children: [
            { title: '物料编码', width: 120, align: 'center', dataIndex: 'itemCode' },
            { title: '物料名称', width: 140, align: 'center', dataIndex: 'itemName' },
            { title: '物料描述', width: 180, align: 'center', dataIndex: 'specification' }
          ]
        },
        {
          title: '制造MBOM，版本号',
          align: 'center',
          dataIndex: 'part1',
          children: [
            { title: '用量', width: 100, align: 'center', dataIndex: 'mbomQuantity' },
            { title: '单位', width: 100, align: 'center', dataIndex: 'mbomMaterialUnit' },
            { title: '备注', width: 120, align: 'center', dataIndex: 'mbomRemark' }
          ]
        },
        {
          title: 'PBOM，版本号',
          align: 'center',
          dataIndex: 'part2',
          children: [
            { title: '用量', width: 100, align: 'center', dataIndex: 'pbomQuantity' },
            { title: '单位', width: 100, align: 'center', dataIndex: 'pbomMaterialUnit' },
            { title: '备注', width: 120, align: 'center', dataIndex: 'pbomRemark' }
          ]
        }
      ]
    }
  },
  methods: {
    // 显示弹窗并获取数据
    show(selectedRow) {
      this.formData = cloneDeep(selectedRow)
      // 生效时间都设为当天
      this.formData.startDate = this.$moment(new Date()).format('YYYY-MM-DD 00:00:00')
      this.loading = true;
      this.$set(this.formData, 'details', [])
      apiMbomBillStructuresDiffDetail({ id: selectedRow.id }).then(res => {
        if (res?.code === 200) {
          this.modal = true
          if(res?.data?.details?.length > 0) {
            this.$set(this.formData, 'details', res?.data?.details)
          }
          if(res.data) {
            this.columns[1].title = `制造MBOM，版本号${res.data?.mbomVersion || ''}`
            this.columns[2].title = `PBOM，版本号${res.data?.pbomVersion || ''}`
          }
        }
      }).finally(() => {
        this.loading = false;
      })
    },
    // 验证生效日期
    validateStartDate() {
      if(!this.formData?.startDate) {
        this.$message.error('请选择生效日期')
        return false
      }
      // 验证生效日期不能早于当天
      const selectedDate = this.$moment(this.formData.startDate)
      const today = this.$moment().startOf('day')
      if(selectedDate.isBefore(today)) {
        this.$message.error('生效日期不能早于当天')
        return false
      }
      return true
    },
    // 打开修改弹窗
    onOpenUpdate() {
      this.modal = false
      this.$emit('update')
    },
    // 是否升级
    onIfUpgrade(flag) {
      if (!this.validateStartDate()) {
        return
      }
      const params = {
        id: this.formData.id,
        startDate: this.formData.startDate,
        upgradeFlag: flag
      }
      this.loading = true;
      apiMbomBillStructuresApply(params).then(res => {
        if (res?.code === 200) {
          this.$message.success(res?.msg || '操作成功')
          this.modal = false
          this.$emit('refresh')
        }
      }).finally(() => {
        this.loading = false;
      })
    },
    // 选择限制当前和以后日期
    disabledDate (current) {
      return current && current <= this.$moment().subtract(1, 'day');
    }
  }
}
</script>

<style scoped>
</style>
